// Milliseconds
export const MS_ONE_HOUR = 1000 * 60 * 60;
export const MS_24_HOURS = MS_ONE_HOUR * 24;

// Seconds
export const SECONDS_TWO_WEEKS = 60 * 60 * 24 * 14;
